// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-item-tags {\n  margin-bottom: 24px;\n}\n.form-item-tags .ant-spin {\n  margin-top: 45px;\n  width: 100%;\n}\n.form-item-tags .ant-transfer {\n  width: 100%;\n  height: 400px;\n}\n.form-item-tags .ant-transfer-list {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
